import React from 'react'
import PropTypes from 'prop-types'

export const Step4AdditionalTees = ({
  source,
  unmatchedTees,
  additionalTeeIds,
  onAdditionalTeeToggle,
}) => {

  if (!unmatchedTees?.length) {
    return (
      <p className="text-center">
        {window.I18n.t('courses.crs.wizard_page_4.no_additional_tees')}
      </p>
    )
  }

  const handleCheckAll = () => {
    unmatchedTees.forEach((tee) => {
      if (!additionalTeeIds.includes(tee.id)) onAdditionalTeeToggle(tee.id, true)
    })
  }

  const handleUncheckAll = () => {
    unmatchedTees.forEach((tee) => onAdditionalTeeToggle(tee.id, false))
  }

  return (
    <div>
      <div className="courses-modal-dropdown-label add-margin-top-10">
        {window.I18n.t(`courses.${source}.popup.copy_additional_tees`)}
      </div>
      <div className="btsp_square_solid customer_box">
        {unmatchedTees.map((tee) => (
          <div key={tee.id} className="fieldset inline check">
            <label className="btsp_icheck_label no-padding-left">
              <div className={`icheckbox_square-orange btsp-icheck-xs icheck-item icheck ${additionalTeeIds.includes(tee.id) ? 'checked' : ''}`}>
                <input type="checkbox" className="icheck-input" checked={additionalTeeIds.includes(tee.id)} onChange={(e) => onAdditionalTeeToggle(tee.id, e.target.checked)} />
              </div>
              <span>{tee.name}</span>
            </label>
          </div>
        ))}
        <div className="fieldset inline check add-margin-top-10">
          <span className="courses-check-all-link" onClick={handleCheckAll}>
            {window.I18n.t('buttons.check_all')}
          </span>
          {' / '}
          <span className="courses-check-all-link" onClick={handleUncheckAll}>
            {window.I18n.t('buttons.uncheck_all')}
          </span>
        </div>
      </div>
    </div>
  )
}

Step4AdditionalTees.propTypes = {
  source: PropTypes.oneOf(['crs', 'scorecentre']).isRequired,
  unmatchedTees: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string, name: PropTypes.string })).isRequired,
  additionalTeeIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  onAdditionalTeeToggle: PropTypes.func.isRequired,
}
